/**
 * SPI Add-to-Cart click interceptor.
 *
 * Dawn cards use a heading <a> whose ::after pseudo-element covers the entire
 * card image. If that overlay sits on top of the ATC button, the link fires
 * instead of the button. This listener runs in capture phase (fires first),
 * detects when a link click occurred within the ATC button's bounding box, and
 * redirects the action to the real button — which product-form.js then handles
 * via Shopify's AJAX cart API.
 *
 * If the button is disabled (sold out) the interceptor steps aside so the
 * normal link click navigates to the product page as expected.
 */
document.addEventListener(
  'click',
  function (e) {
    // If the click already landed on the ATC element or its children, leave it alone.
    if (e.target.closest('.spi-card-atc')) return;

    // Only act on link clicks (the heading ::after fires on the <a> element).
    const link = e.target.closest('a');
    if (!link) return;

    // Must be inside a product card wrapper.
    const wrapper = link.closest('.card-wrapper');
    if (!wrapper) return;

    // Find the ATC element for this card.
    const atc = wrapper.querySelector('.spi-card-atc');
    if (!atc) return;

    // Check whether the click coordinates fall inside the ATC button area.
    const rect = atc.getBoundingClientRect();
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) return;

    // Check if the button is actionable BEFORE intercepting.
    // If disabled (sold out) or missing, let the link navigate to the product page.
    const btn = atc.querySelector('.spi-card-atc__btn');
    if (!btn || btn.disabled || btn.tagName === 'BUTTON' && btn.hasAttribute('disabled')) return;

    // Button is available — intercept the link and trigger the ATC button instead.
    e.stopImmediatePropagation();
    e.preventDefault();
    btn.click();
  },
  true // capture phase — runs before any other handler
);
